// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import AssessLanding from './components/AssessLanding';
import Assess from './components/Assess';
import AncientStyleCouplet from './components/AncientStyleCouplet';
import AncientStyleJueju from './components/AncientStyleJueju';
import PingZeRegulatedCouplet from './components/PingZeRegulatedCouplet';
import PingZeRegulatedJueju from './components/PingZeRegulatedJueju';
import Learn from './components/Learn';
import NewmanPrize from './components/NewmanPrize';
import PingZeAssess from './components/PingZeAssess';
import ViewJinshiSubmissions from './components/ViewJinshiSubmissions';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/Dashboard';
import AboutJueju from './components/AboutJueju';
import AboutWebsite from './components/AboutWebsite';
import AboutEnglishJueju from './components/AboutEnglishJueju';
import RegLearn from './components/RegLearn';
import ProtectedRoute from './ProtectedRoute'; // Import the ProtectedRoute component
import TeacherDashboard from './components/Teacher';
import ResetPassword from './components/ResetPassword'; 
import RateSubmissions from './components/RateSubmissions'; 
import './App.css';

function App() {
  useEffect(() => {
    // Any additional logic can go here if needed
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/assess"
            element={
              <ProtectedRoute>
                <AssessLanding />
              </ProtectedRoute>
            }
          />

          <Route
            path="/assess/full"
            element={
              <ProtectedRoute>
  	              <Assess />
              </ProtectedRoute>
            }
          />

          <Route
             path="/assess/full/ancient-couplet"
	     element={
	      <ProtectedRoute>
		<AncientStyleCouplet />
	      </ProtectedRoute>
	     }
	  />

	  <Route
             path="/assess/full/ancient-jueju"
	     element={
	      <ProtectedRoute>
		 <AncientStyleJueju />
	      </ProtectedRoute>
	     }
	  />


          <Route
            path="/assess/pingze-assess"
            element={
              <ProtectedRoute>
                <PingZeAssess />
              </ProtectedRoute>
            }
          />

	  <Route
            path="/assess/pingze/regulated-couplet"
            element={
	      <ProtectedRoute>
		<PingZeRegulatedCouplet />
              </ProtectedRoute>
	    }
	  />

	<Route
	  path="/assess/pingze/regulated-jueju"
	  element={
	    <ProtectedRoute>
	      <PingZeRegulatedJueju />
	    </ProtectedRoute>
	  }
	/>	

          <Route 
            path="/learn" 
            element={
              <ProtectedRoute>
                <Learn />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/regulated" 
            element={
              <ProtectedRoute>
                <RegLearn />
              </ProtectedRoute>
            } 
          />
	  <Route
            path="/newmanprize"
            element={
              <ProtectedRoute>
                <NewmanPrize />
              </ProtectedRoute>
            }
          />
	  <Route path="/Jinshi" element={<ViewJinshiSubmissions />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route 
            path="/about/jueju" 
            element={
              <ProtectedRoute>
                <AboutJueju />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/about/english-jueju" 
            element={
              <ProtectedRoute>
                <AboutEnglishJueju />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/about/website" 
            element={
              <ProtectedRoute>
                <AboutWebsite />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/learn/examination-path" 
            element={
              <ProtectedRoute>
                <Learn />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/teacher/dashboard" 
            element={
              <ProtectedRoute>
                <TeacherDashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route 
            path="/rate-submissions" 
            element={
              <ProtectedRoute jinshiRequired={false}>
                <RateSubmissions />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


